import {Link} from "@/i18n/routing";
import bgImage9 from "@/assets/img/bg/9.jpg";
import {useTranslations} from 'next-intl';

export default function HeroPrimary({ text, title, item, type, noText, background }) {
  const t = useTranslations('header.banner');
  if (noText) {
    return (
        <div
            className={`ltn__breadcrumb-area ltn__breadcrumb-color-white bg-overlay-theme-black-90 bg-image`}
            data-bs-bg={background ?? bgImage9.src}
        ></div>
    );
  }
  return (
    <div
      className={`ltn__breadcrumb-area ${
        type === 3
          ? "ltn__breadcrumb-area-2 plr--9"
          : type === 2
                ? "ltn__breadcrumb-area-3 plr--9"
                : "ltn__breadcrumb-area-2"
      } ltn__breadcrumb-color-white bg-overlay-theme-black-90 bg-image`}
      data-bs-bg={background ?? bgImage9.src}
    >
      <div className={type === 2 || type === 3 ? "container-fluid" : "container"}>
        <div className="row">
          <div className="col-lg-12">
            <div className="ltn__breadcrumb-inner ltn__breadcrumb-inner-2 justify-content-between">
              <div className="section-title-area ltn__section-title-2">
                {/*<h6 className="section-subtitle ltn__secondary-color">*/}
                {/*  {"//"} {t('welcomeTo')}*/}
                {/*</h6>*/}
                <h3 className="section-title white-color">
                  {
                    typeof title === 'string' ? title : t('filterIs', {
                      filter: t(title.queryParam),
                      title: title.title
                    })
                  }
                </h3>
              </div>
              <div className="ltn__breadcrumb-list">
                <ul>
                  <li>
                    <Link href="/">{t('home')}</Link>
                  </li>{" "}
                  {item ? (
                    <li>
                      <Link href={item.path}>{item.name}</Link>
                    </li>
                  ) : ("")}{" "}
                  <li>{text}</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
